import { Button } from "@mui/material";
import { exportDataGridToExcel } from "../../utils/excel";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { GridColDef } from "@mui/x-data-grid";

export interface ExcelExportButtonProps {
  columns: GridColDef[];
  rows: any[];
}

const ExcelExportButton: React.FC<ExcelExportButtonProps> = ({
  columns,
  rows,
}) => {
  const handleExport = async () => {
    try {
      await exportDataGridToExcel(columns, rows, "export");
    } catch (error) {
      console.error("Export failed:", error);
      alert("Failed to export data. Please check console for details.");
    }
  };
  return (
    <Button
      color="success"
      variant="outlined"
      size="small"
      onClick={() => handleExport()}
      startIcon={<FileDownloadIcon />}
    >
      Esporta Excel
    </Button>
  );
};

export default ExcelExportButton;
